'use strict';

var React = require('react');
var styled = require('styled-components');
var header = require('./Cells/header.js');
var row_styles = require('./row.styles.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);
var styled__default = /*#__PURE__*/_interopDefaultCompat(styled);

const rowHeaderHoverStyle = styled.css `
  ${header.GrabColStyled} {
    border-right-color: ${({ theme }) => theme.palette.grey300};
  }
`;
const RowHeader = styled__default.default.tr `
  background-color: ${({ theme }) => theme.designTokens.tableAlternateRowBackgroundColor};
  border-bottom: 1px solid ${({ theme }) => theme.colors.border};
  &:hover {
    ${rowHeaderHoverStyle}
  }
  ${({ $grabColsVisible }) => $grabColsVisible && rowHeaderHoverStyle}
`;
const CellExpanded = styled__default.default.td `
  padding: 0;
`;
const Row = ({ isExpanded = false, columnsCount, renderExpandedRow, data, $isAlt, $isSelected, ...props }) => {
    const expandable = renderExpandedRow !== undefined;
    return (React__default.default.createElement(React__default.default.Fragment, null, expandable && data ? (React__default.default.createElement(React__default.default.Fragment, null,
        React__default.default.createElement(row_styles.TableRowStyled, { "$isAlt": $isAlt, ...props, "aria-expanded": isExpanded }),
        React__default.default.createElement(row_styles.TableRowStyled, { "$isAlt": $isAlt, "$noHover": true, "$collapsable": true },
            React__default.default.createElement(CellExpanded, { colSpan: columnsCount },
                React__default.default.createElement(row_styles.CellExpandedContent, { id: `${props.id}-expanded` },
                    React__default.default.createElement(row_styles.CellExpandedContentPadding, null, renderExpandedRow({ data }))))))) : (React__default.default.createElement(row_styles.TableRowStyled, { "$isAlt": $isAlt, "$isSelected": $isSelected, ...props }))));
};

exports.CellExpanded = CellExpanded;
exports.Row = Row;
exports.RowHeader = RowHeader;
//# sourceMappingURL=row.js.map
